export const SET_CONSTANTS = 'SET_CONSTANTS';
export const SET_PREDICATES = 'SET_PREDICATES';
export const SET_FUNCTIONS = 'SET_FUNCTIONS';
export const SET_DIAGRAM = 'SET_DIAGRAM';
export const LOCK_CONSTANTS = 'LOCK_CONSTANTS';
export const LOCK_PREDICATES = 'LOCK_PREDICATES';
export const LOCK_FUNCTIONS = 'LOCK_FUNCTIONS';
export const LOCK_LANGUAGE_COMPONENT = 'LOCK_LANGUAGE_COMPONENT';
export const SET_CONSTANT_VALUE = 'SET_CONSTANT_VALUE';
export const SET_PREDICATE_VALUE_TEXT = 'SET_PREDICATE_VALUE_TEXT';
export const SET_PREDICATE_VALUE_TABLE = 'SET_PREDICATE_VALUE_TABLE';
export const SET_FUNCTION_VALUE_TEXT = 'SET_FUNCTION_VALUE_TEXT';
export const SET_FUNCTION_VALUE_TABLE = 'SET_FUNCTION_VALUE_TABLE';
export const LOCK_CONSTANT_VALUE = 'LOCK_CONSTANT_VALUE';
export const LOCK_PREDICATE_VALUE = 'LOCK_PREDICATE_VALUE';
export const LOCK_FUNCTION_VALUE = 'LOCK_FUNCTION_VALUE';
export const SET_VARIABLES_VALUE = 'SET_VARIABLES_VALUE';
export const SYNC_DIAGRAM = 'SYNC_DIAGRAM';
export const SET_DOMAIN = 'SET_DOMAIN';
export const SYNC_MATH_STATE = 'SYNC_MATH_STATE';
export const RENAME_DOMAIN_NODE = 'RENAME_DOMAIN_NODE';
export const RENAME_CONSTANT_NODE = 'RENAME_CONSTANT_NODE';
export const ADD_UNARY_PREDICATE = 'ADD_UNARY_PREDICATE';
export const REMOVE_UNARY_PREDICATE = 'REMOVE_UNARY_PREDICATE';
export const ADD_BINARY_PREDICATE = 'ADD_BINARY_PREDICATE';
export const REMOVE_BINARY_PREDICATE = 'REMOVE_BINARY_PREDICATE';
export const ADD_CONSTANT_NODE = 'ADD_CONSTANT_NODE';
export const REMOVE_CONSTANT_NODE = 'REMOVE_CONSTANT_NODE';
export const RESET_DIAGRAM_STATE = 'RESET_DIAGRAM_STATE';
export const ADD_DOMAIN_NODE = 'ADD_DOMAIN_NODE';
export const ADD_TERNARY_NODE = 'ADD_TERNARY_NODE';
export const ADD_QUATERNARY_NODE = 'ADD_QUATERNARY_NODE';
export const REMOVE_DOMAIN_NODE = 'REMOVE_DOMAIN_NODE';
export const REMOVE_TERNARY_NODE = 'REMOVE_TERNARY_NODE';
export const REMOVE_QUATERNARY_NODE = 'REMOVE_QUATERNARY_NODE';
export const ADD_TERNARY_PREDICATE = 'ADD_TERNARY_PREDICATE';
export const REMOVE_TERNARY_PREDICATE = 'REMOVE_TERNARY_PREDICATE';
export const ADD_QUATERNARY_PREDICATE = 'ADD_QUATERNARY_PREDICATE';
export const REMOVE_QUATERNARY_PREDICATE = 'REMOVE_QUATERNARY_PREDICATE';
export const ADD_UNARY_FUNCTION = 'ADD_UNARY_FUNCTION';
export const REMOVE_UNARY_FUNCTION = 'REMOVE_UNARY_FUNCTION';
export const ADD_BINARY_FUNCTION = 'ADD_BINARY_FUNCTION';
export const REMOVE_BINARY_FUNCTION = 'REMOVE_BINARY_FUNCTION';
export const ADD_TERNARY_FUNCTION = 'ADD_TERNARY_FUNCTION';
export const REMOVE_TERNARY_FUNCTION = 'REMOVE_TERNARY_FUNCTION';
export const CHANGE_DIRECTION_OF_BINARY_RELATION = 'CHANGE_DIRECTION_OF_BINARY_RELATION';
export const SET_CONSTANT_VALUE_FROM_LINK = 'SET_CONSTANT_VALUE_FROM_LINK';
export const IMPORT_DIAGRAM_STATE = 'IMPORT_DIAGRAM_STATE';
export const CLEAR_GRAPH_SELECTION = 'CLEAR_GRAPH_SELECTION';
export const LOCK_DOMAIN = 'LOCK_DOMAIN';
export const LOCK_VARIABLES = 'LOCK_VARIABLES';
export const IMPORT_APP = 'IMPORT_APP';
export const ADD_EXPRESSION = 'ADD_EXPRESSION';
export const REMOVE_EXPRESSION = 'REMOVE_EXPRESSION';
export const SET_EXPRESSION_ANSWER = 'SET_EXPRESSION_ANSWER';
export const LOCK_EXPRESSION_VALUE = 'LOCK_EXPRESSION_VALUE';
export const LOCK_EXPRESSION_ANSWER = 'LOCK_EXPRESSION_ANSWER';
export const CHECK_SYNTAX = 'CHECK_SYNTAX';
export const TOGGLE_EDIT_TABLE = 'TOGGLE_EDIT_TABLE';
export const TOGGLE_EDIT_DATABASE = 'TOGGLE_EDIT_DATABASE';
export const TOGGLE_TEACHER_MODE = 'TOGGLE_TEACHER_MODE';
export const TOGGLE_EDITABLE_NODES = 'TOGGLE_EDITABLE_NODES';
export const INITIATE_GAME = 'INITIATE_GAME';
export const SET_GAME_COMMITMENT = 'SET_GAME_COMMITMENT';
export const CONTINUE_GAME = 'CONTINUE_GAME';
export const SET_GAME_DOMAIN_CHOICE = 'SET_GAME_DOMAIN_CHOICE';
export const END_GAME = 'END_GAME';
export const SET_GAME_NEXT_FORMULA = 'SET_GAME_NEXT_FORMULA';
export const GO_BACK = 'GO_BACK';
export const GET_VARIABLES = 'GET_VARIABLES';